import {
  AutoLinkPlugin,
  createLinkMatcherWithRegExp,
} from "@lexical/react/LexicalAutoLinkPlugin";
import { useMemo } from "react";

// Store regex in string instead of regex literal since some bundler might hoist regex to module level
// and potentially crash the app when uses unsupported regex in older browser
const URL_REGEX_PATTERN =
  "((https?:\\/\\/(www\\.)?)||(www\\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\\.[a-zA-Z0-9()]{1,6}\\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)";

const EMAIL_REGEX =
  /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;

export default function LexicalAutoLinkPlugin(): JSX.Element {
  const MATCHERS = useMemo(() => {
    // The lookbehind pattern - only add if supported
    let urlRegex;
    try {
      // Test if lookbehind is supported
      new RegExp("(?<!test)");
      urlRegex = new RegExp(URL_REGEX_PATTERN + "(?<![-.+():%])");
    } catch (error) {
      urlRegex = new RegExp(URL_REGEX_PATTERN);
    }

    return [
      createLinkMatcherWithRegExp(urlRegex, (text) => {
        return text.startsWith("http") ? text : `https://${text}`;
      }),
      createLinkMatcherWithRegExp(EMAIL_REGEX, (text) => {
        return `mailto:${text}`;
      }),
    ];
  }, []);
  return <AutoLinkPlugin matchers={MATCHERS} />;
}
